import { render, staticRenderFns } from "./CustomTabs.vue?vue&type=template&id=60574642&lang=pug&"
import script from "./CustomTabs.vue?vue&type=script&lang=js&"
export * from "./CustomTabs.vue?vue&type=script&lang=js&"
import style0 from "./CustomTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VFlex,VLayout,VTab,VTabs})
